import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { SecurityService } from '@dworkflow/shared/services/security.service';
import { TenantService } from '@dworkflow/shared/services/tenant.service';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';
import * as pollingActions from '../../state/polling.actions';

@Injectable({
  providedIn: 'root',
})

// Guard fuer Routen, die nur von FachAdmins oder SysAdmins geoeffnet werden duerfen
export class CanActivateAdministratorGuard {
  private securityService = inject(SecurityService);
  private tenantService = inject(TenantService);
  private store = inject(Store);

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Zugriff auf SystemAdmins einschraenken durch Setzen von 'restrictedToSystemAdminsOnly'
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const restrictedToSystemAdminsOnly = route.data?.restrictedToSystemAdminsOnly;

    // ist notwendig, da bei Refresh der Routen, die mit diesem Guard per canActiavte abgesichert sind, 
    // keine RouterNavigated Action vor dem Aufruf dieser Aktion dispatched wird. 
    // Dies führt zu einem unendlichen Ladekringel.
    this.store.dispatch(pollingActions.pollCheckLogin());

    return this.securityService.getCurrentUser().pipe(
      map(user => {
        if (
          (restrictedToSystemAdminsOnly && user.isSystemAdmin) ||
          (!restrictedToSystemAdminsOnly && (user.isWorkflowAdministrator || user.isSystemAdmin))
        ) {
          return true;
        }

        this.tenantService.redirectForbidden();

        return false;
      })
    );
  }
}

export const AuthGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  return inject(CanActivateAdministratorGuard).canActivate(next, state);
};
